import {
    Button,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../../configs/messages';
import { getDataItem } from '../../../../helpers/getDataItem';
import { getDataList } from '../../../../helpers/getDataList';
import showMessage from '../../../../helpers/showMessage';
import './programDetailEdit.css';
import { sendFormData } from '../../../../helpers/sendFormData';
import { BOOLEAN_TYPES } from '../../../../configs/constants';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import { ROUTES_LIST } from '../../../../helpers/routesList';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export function ProgramDetailEdit({ isEdit }) {
    const [errors, setErrors] = useState({});
    const [allProgramType, setAllProgramType] = useState([]);
    const [initialData, setInitialData] = useState({
        broadcastDate: format(new Date(), 'yyyy-MM-dd'),
        broadcastTime: format(new Date(), 'HH:mm'),
        duration: '',
        name: '',
        isRepeat: false,
        programTypeId: '',
        description: '',
        imgUrl: '',
        image: null,
        epNo: '',
        epTitle: '',
        actors: '',
        directors: '',
        language: '',
        productYear: '',
        genre: '',
        parentalRating:'',
    });
    const [ data, setData] = useState('')
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const { id } = useParams();
console.log("data==>",initialData)
    useEffect(() => {
        let isActive = true;
        const getData = async () => {
            try {
                const typeResponse = await getDataList('program-type');
                console.log('Type response:', typeResponse); // Log the type response
                const allProgramType = typeResponse.data?.data;
                if (isActive) {
                    setAllProgramType(allProgramType);
                }

                const formDataResponse = await getDataItem(`program-detail-list/detail/${id}`).then(({ data }) => {
                if (isActive) {
                    delete data.data?.id;
                    setInitialData(data.data);
                    // setVooChannels(data.data);
                }
            })
             
            } catch (error) {
                console.error('Error fetching data:', error); // Log the error
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            }
        };

        getData();

        return () => {
            isActive = false;
        };
    }, [id]);

    const validate = () => {
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
        const broadcastWeek = initialData?.epgProgram?.broadcastWeek;
        const week = broadcastWeek.split('-');
        const tempErrors = {};

        if ('broadcastDate' in initialData) {
            if (initialData.broadcastDate) {
                const currentDate = initialData.broadcastDate.replace(/-/g, '\/');
                if (week[0] > currentDate || currentDate > week[1]) {
                    tempErrors.broadcastDate = ERROR_MESSAGES.NOT_IN_DATE_RANGE;
                } else {
                    tempErrors.broadcastDate = '';
                }
            } else {
                tempErrors.broadcastDate = requiredMessage;
            }
        }

        if ('name' in initialData) {
            tempErrors.name = initialData.name ? '' : requiredMessage;
        }
        if ('programTypeId' in initialData) {
            tempErrors.programTypeId = initialData.programTypeId ? '' : requiredMessage;
        }

        setErrors({ ...tempErrors });

        return tempErrors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setInitialData({
            ...initialData,
            [name]: value,
        });
    };

    const handleImageInsert = (e) => {
        const uploadedFiles = e.target.files;

        if (uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0].size > 2097152) {
            showMessage(
                ERROR_MESSAGES.FILE_SIZE_TOO_BIG,
                enqueueSnackbar,
                'error',
            );
            setInitialData({
                ...initialData,
                image: null,
                imgUrl: null,
            });
        } else if (uploadedFiles && uploadedFiles.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setInitialData({
                    ...initialData,
                    image: uploadedFiles[0],
                    imgUrl: reader.result,
                });
            };

            reader.readAsDataURL(uploadedFiles[0]);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestBody = { ...initialData };
        delete requestBody.imgUrl;
        sendFormData(requestBody, `program-detail-list/detail/${id}`, true)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.epgPage);
            })
            .catch((error) => {
                console.error('Error submitting data:', error); // Log the error
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    return (
        <>
            <form style={{ width: '80%', display: 'inline-block' }}>
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%', margin: 0 }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{
                            boxShadow: '0 0 34px 9px rgba(0,0,0,.05)',
                            padding: '20px 0',
                            margin: 0,
                        }}
                    >
                        <Grid item>
                        
                            <span
                                style={{
                                    display: 'inline-block',
                                    margin: '8px 35px 8px 0px',
                                }}
                            >
                                 <TextField
                                    id="program-detail-date"
                                    label="Хөтөлбөрийн өдөр"
                                    type="date"
                                    name='broadcastDate'
                                    value={initialData.broadcastDate}
                                    sx={{ width: 220 }}
                                    InputLabelProps={{
                                    shrink: true,
                                    }}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.broadcastDate)}
                                    helperText={errors.broadcastDate}
                                />
                            </span>
                            <span
                                style={{
                                    display: 'inline-block',
                                    margin: '8px 35px 8px 0px',
                                }}
                            >
                                <TextField
                                    id="program-detail-time"
                                    label="Хөтөлбөрийн цаг"
                                    type="time"
                                    name="broadcastTime"
                                    value={initialData.broadcastTime}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    sx={{ width: 150 }}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.broadcastTime)}
                                    helperText={errors.broadcastTime}
                                />
                            </span>

                            <FormControl sx={{ m: 1, width: '300px' }}>
                                <InputLabel id="program-type-select">
                                    Хөтөлбөрийн төрөл
                                </InputLabel>
                                <Select
                                    labelId="program-type-select"
                                    value={initialData.programTypeId}
                                    onChange={handleInputChange}
                                    label="Хөтөлбөрийн төрөл"
                                    name="programTypeId"
                                    MenuProps={MenuProps}
                                    error={Boolean(errors.programTypeId)}
                                >
                                    <MenuItem value="">
                                        <em style={{ fontStyle: 'normal' }}>
                                            Хөтөлбөрийн төрөл
                                        </em>
                                    </MenuItem>
                                    {allProgramType.map((programType) => (
                                        <MenuItem
                                            key={programType.id}
                                            value={programType.id}
                                        >
                                            {programType.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {Boolean(errors.programTypeId) && (
                                    <FormHelperText
                                        style={{ color: '#d32f2f' }}
                                    >
                                        {errors.programTypeId}
                                    </FormHelperText>
                                )}
                            </FormControl>

                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.duration}
                                variant="standard"
                                label="Хөтөлбөрийн үргэлжлэх хугацаа"
                                fullWidth
                                name="duration"
                                onChange={handleInputChange}
                                error={Boolean(errors.duration)}
                                helperText={errors.duration}
                            />
            
                            <FormControl sx={{ m: 1, width: '300px' }}>
                                <InputLabel id="program-repeat">
                                    Давтагдах эсэх
                                </InputLabel>
                                <Select
                                    labelId="program-repeat"
                                    value={initialData.isRepeat}
                                    onChange={handleInputChange}
                                    label="Давтагдах эсэх"
                                    name="isRepeat"
                                    MenuProps={MenuProps}
                                    error={Boolean(errors.isRepeat)}
                                >
                                    <MenuItem value="">
                                        <em style={{ fontStyle: 'normal' }}>
                                            Давтагдах эсэх
                                        </em>
                                    </MenuItem>
                                    {BOOLEAN_TYPES.map((type) => (
                                        <MenuItem
                                            key={type.type}
                                            value={type.type}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.name}
                                variant="standard"
                                label="Хөтөлбөрийн Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}  
                            />
                          
                        </Grid>

                        {/* -------------------------------------------------- */}
                         <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.epNo}
                                variant="standard"
                                label="Дугаар"
                                fullWidth
                                name="epNo"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                            <TextField
                                sx={{ width: '45%' }}
                                value={initialData.epTitle}
                                variant="standard"
                                label="Гарчиг"
                                fullWidth
                                name="epTitle"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.actors}
                                variant="standard"
                                label="Жүжигчид"
                                fullWidth
                                name="actors"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                            <TextField
                                sx={{ width: '45%' }}
                                value={initialData.directors}
                                variant="standard"
                                label="Найруулагч"
                                fullWidth
                                name="directors"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                         <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.language}
                                variant="standard"
                                label="Хэл"
                                fullWidth
                                name="language"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                            <TextField
                                sx={{ width: '45%' }}
                                value={initialData.productYear}
                                variant="standard"
                                label="Хийгдсэн он"
                                fullWidth
                                name="productYear"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                sx={{ width: '50%', marginRight: '15px' }}
                                value={initialData.genre}
                                variant="standard"
                                label="Жанар"
                                fullWidth
                                name="genre"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                            <TextField
                                sx={{ width: '45%' }}
                                value={initialData.parentalRating}
                                variant="standard"
                                label="Үнэлгээ"
                                fullWidth
                                name="parentalRating"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                            sx={{ width: '45%', height: '45%' }}
                            value={initialData.description}
                            variant="standard"
                            label="Тайлбар"
                            fullWidth
                            name="description"
                            onChange={handleInputChange}
                            error={Boolean(errors.description)}
                            helperText={errors.description}
                            multiline
                            rows={3} // Adjust the number of rows as needed
                            />
                        </Grid>
                        {/* ------------------------------------------ */}
                    </Grid>
                    <Grid item container direction="column" gap="20px">
                        <div>
                            {initialData.imgUrl && (
                                <img
                                    src={initialData.imgUrl}
                                    alt="зураг"
                                    style={{
                                        height: '300px',
                                        width: '400px',
                                        objectFit: 'cover',
                                    }}
                                />
                            )}
                        </div>
                        {/* {errors.image ? (
                            <InputErrorMessage errorMessage={errors.image} />
                        ) : null} */}
                        <div>
                            <p style={{ fontSize: '12px' }}>
                                Зургийн харьцаа 4:3 (800x600), зургийн хэмжээ
                                дээд 2mb
                            </p>
                            <Button variant="contained" component="label">
                                <input
                                    hidden
                                    accept="image/*"
                                    type="file"
                                    onChange={handleImageInsert}
                                />
                                Thumbnail зураг оруулах
                            </Button>
                        </div>
                    </Grid>

                    <Grid
                        item
                        container
                        direction="row"
                        justifyContent="space-between"
                        style={{ marginTop: '20px' }}
                    >
                        <Grid item>
                            <Button
                                variant="outlined"
                                type="button"
                                onClick={() => history.goBack()}
                            >
                                <ArrowBackIcon />
                                <Typography style={{ marginLeft: '10px' }}>
                                    Буцах
                                </Typography>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                color="success"
                                style={{ marginLeft: '10px' }}
                                type="submit"
                                variant="outlined"
                                onClick={(e) => handleSubmit(e)}
                            >
                                <SaveAltIcon />
                                <Typography style={{ marginLeft: '10px' }}>
                                    Хадгалах
                                </Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </>
    );
}
